import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { PlanService } from '../services/plan.service';
import { PermissionService } from '../../features/security/services/permission.service';

/**
 * UN REFUS DOIT SE DIRE.
 *
 * ── LE DEFAUT, RAPPORTE ──
 *
 * « Lorsque je clique sur Taxe je n'ai rien. »
 *
 * Le garde renvoyait vers `/dashboard` en posant `?upgradeRequired=<module>`
 * ou `?noPlan=true`. Ces deux parametres etaient lus par PERSONNE — verifie
 * sur tout le frontend, seules les assertions de ce spec les mentionnaient.
 * L'utilisateur cliquait, revenait au tableau de bord, et rien ne lui disait
 * pourquoi. Un refus muet se lit comme une panne.
 *
 * Le cas rencontre : l'entreprise Alez Auto Parts est sur le plan Family, qui
 * porte `has_tax_engine = false`. Le refus etait donc JUSTE — c'est son
 * silence qui ne l'etait pas.
 *
 * ── CE QUI A CHANGE ──
 *
 * Le garde annoncait le refus par un message ephemere (6 s). L'accueil lit
 * maintenant `?upgradeRequired=<module>` et `?noPlan=true` et affiche un
 * bandeau qui reste a l'ecran, avec un lien vers les plans. Garder AUSSI le
 * message doublait l'annonce : le garde ne fait plus que rediriger, c'est
 * l'accueil qui explique. Le refus reste dit — a un endroit au lieu de deux.
 */
export const moduleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const planService = inject(PlanService);
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    /** Refuse : l'accueil lit les paramètres et dit pourquoi. */
    const refuser = (queryParams: Record<string, string>) =>
        router.createUrlTree(['/dashboard'], { queryParams });

    // Super admin bypasses all module gates
    if (permissionService.isSuperAdmin()) return true;

    // No active plan → block all module-gated routes
    if (!planService.hasActivePlan()) {
        return refuser({ noPlan: 'true' });
    }

    const requiredModule = route.data['requiredModule'] as string;
    if (!requiredModule) return true;

    if (planService.checkModuleByName(requiredModule)) {
        return true;
    }

    return refuser({ upgradeRequired: requiredModule });
};
